import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import scrollToTop from 'commons/scrollToTop';
import scrollIntoViewUtil from 'commons/scrollIntoViewUtil';
import useScreen from 'hooks/useScreen';
import DesktopOnly from 'components/consumer/DesktopOnly';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPNotification from '../PDPNotification';
import PDPLeadTimeUI from '../PDPNameSection/PDPLeadTimeUI';
import PDPAlertBar from '../PDPAlertBar';
import useShowStickyButtons from './hooks/useShowStickyButtons';
import PDPAvailableInSizesListItem from '../PDPAvailableInSizes/PDPAvailableInSizesRow/PDPAvailableInSizesListItem';
import PDPAddToBagButton from './PDPAddToBagButton';
const PDPAddToBagSectionUI = t0 => {
  const $ = _c(79);
  const {
    addingToCart,
    addToCartError,
    allowUserToCustomize,
    buildYourOwnDetails: t1,
    campaign,
    cartDisabled,
    isDiscontinued: t2,
    isModularBundleProduct: t3,
    isOutOfStock: t4,
    loading,
    mode: t5,
    onAddToCart,
    selectedMaterial,
    showClearanceAlert: t6,
    stickyDesktopButtonOnly: t7
  } = t0;
  let t8;
  if ($[0] !== t1) {
    t8 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const buildYourOwnDetails = t8;
  const isDiscontinued = t2 === undefined ? false : t2;
  const isModularBundleProduct = t3 === undefined ? false : t3;
  const isOutOfStock = t4 === undefined ? false : t4;
  const mode = t5 === undefined ? "pdp" : t5;
  const showClearanceAlert = t6 === undefined ? false : t6;
  const stickyDesktopButtonOnly = t7 === undefined ? false : t7;
  const {
    isMobileOrTablet
  } = useScreen();
  const addToBagSectionRef = useRef(null);
  const [overrideCustomize, setOverrideCustomize] = useState(false);
  const isBrowser = useIsBrowser();
  const [showClearanceMobileNotification, setShowClearanceMobileNotification] = useState(false);
  const {
    data: pdpClearanceData
  } = usePDPClearanceData();
  const isFlashSale = pdpClearanceData?.optionsClearanceData?.[selectedMaterial?.sku]?.flashSale || false;
  pdpClearanceData?.optionsClearanceData;
  let t9;
  if ($[2] !== pdpClearanceData?.optionsClearanceData) {
    t9 = Object.keys(pdpClearanceData?.optionsClearanceData || {});
    $[2] = pdpClearanceData?.optionsClearanceData;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const clearanceOptions = t9;
  let t10;
  let t11;
  if ($[4] !== stickyDesktopButtonOnly) {
    t10 = () => {
      if (stickyDesktopButtonOnly) {
        addToBagSectionRef.current = document.querySelector("[data-xc=\"PDPAddToBagSectionUI\"]");
      }
    };
    t11 = [stickyDesktopButtonOnly];
    $[4] = stickyDesktopButtonOnly;
    $[5] = t10;
    $[6] = t11;
  } else {
    t10 = $[5];
    t11 = $[6];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[7] !== clearanceOptions || $[8] !== selectedMaterial) {
    t12 = () => {
      if (clearanceOptions.length > 0 && selectedMaterial?.sku) {
        const isSelectedOptionOnClearance = clearanceOptions.includes(selectedMaterial.sku) || false;
        setShowClearanceMobileNotification(isSelectedOptionOnClearance);
      }
    };
    t13 = [clearanceOptions, selectedMaterial];
    $[7] = clearanceOptions;
    $[8] = selectedMaterial;
    $[9] = t12;
    $[10] = t13;
  } else {
    t12 = $[9];
    t13 = $[10];
  }
  useEffect(t12, t13);
  const showStickyButtons = useShowStickyButtons(addToBagSectionRef);
  let t14;
  if ($[11] !== isMobileOrTablet) {
    t14 = () => {
      if (isMobileOrTablet) {
        scrollIntoViewUtil("[data-xc=\"MaterialThumbnailGroup\"]");
      } else {
        scrollToTop();
      }
    };
    $[11] = isMobileOrTablet;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  const onCustomizeClick = t14;
  let t15;
  if ($[13] !== allowUserToCustomize || $[14] !== onAddToCart || $[15] !== onCustomizeClick || $[16] !== overrideCustomize) {
    t15 = (event, isStickyButton) => {
      if (isStickyButton && allowUserToCustomize && !overrideCustomize) {
        onCustomizeClick();
      } else {
        onAddToCart();
      }
      setOverrideCustomize(true);
    };
    $[13] = allowUserToCustomize;
    $[14] = onAddToCart;
    $[15] = onCustomizeClick;
    $[16] = overrideCustomize;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  const onClick = t15;
  if (stickyDesktopButtonOnly) {
    const t16 = !showStickyButtons;
    let t17;
    if ($[18] !== showStickyButtons || $[19] !== t16) {
      t17 = classNames("transition-opacity ease-in max-[1023px]:hidden whitespace-nowrap", {
        invisible: t16,
        visible: showStickyButtons
      });
      $[18] = showStickyButtons;
      $[19] = t16;
      $[20] = t17;
    } else {
      t17 = $[20];
    }
    const t18 = allowUserToCustomize && !overrideCustomize;
    let t19;
    if ($[21] !== addToCartError || $[22] !== addingToCart || $[23] !== campaign || $[24] !== cartDisabled || $[25] !== loading || $[26] !== onClick || $[27] !== t18) {
      t19 = <PDPAddToBagButton addingToCart={addingToCart} addToCartError={addToCartError} campaign={campaign} cartDisabled={cartDisabled} loading={loading} isCustomizeButton={t18} isStickyButton={true} onClick={onClick} />;
      $[21] = addToCartError;
      $[22] = addingToCart;
      $[23] = campaign;
      $[24] = cartDisabled;
      $[25] = loading;
      $[26] = onClick;
      $[27] = t18;
      $[28] = t19;
    } else {
      t19 = $[28];
    }
    let t20;
    if ($[29] !== t17 || $[30] !== t19) {
      t20 = <DesktopOnly><div className={t17}>{t19}</div></DesktopOnly>;
      $[29] = t17;
      $[30] = t19;
      $[31] = t20;
    } else {
      t20 = $[31];
    }
    return t20;
  }
  if (isDiscontinued) {
    let t16;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <><div /><div /></>;
      $[32] = t16;
    } else {
      t16 = $[32];
    }
    return t16;
  }
  const t16 = mode === "quickview";
  let t17;
  if ($[33] !== t16) {
    t17 = classNames("PDPAddToBagSectionUI mt-8", {
      "mt-0 md:mt-4": t16
    });
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== addToCartError || $[36] !== addingToCart || $[37] !== campaign || $[38] !== cartDisabled || $[39] !== loading || $[40] !== onClick) {
    t18 = <ReRenderOnMount><PDPAddToBagButton addingToCart={addingToCart} addToCartError={addToCartError} campaign={campaign} cartDisabled={cartDisabled} loading={loading} onClick={onClick} /></ReRenderOnMount>;
    $[35] = addToCartError;
    $[36] = addingToCart;
    $[37] = campaign;
    $[38] = cartDisabled;
    $[39] = loading;
    $[40] = onClick;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== isBrowser || $[43] !== isOutOfStock || $[44] !== loading || $[45] !== mode || $[46] !== showClearanceAlert) {
    t19 = !isOutOfStock ? <div>{!isBrowser || loading ? <Placeholder type="rect" loading={true} style={{
        height: "12px",
        marginTop: "20px"
      }} /> : <div className="flex items-center justify-center flex-wrap"><PDPLeadTimeUI mode={mode} /></div>}{!loading && showClearanceAlert && <DesktopOnly><div className="max-[1023px]:hidden"><PDPAlertBar type="info">{"Clearance item: ineligible for returns except for items arriving damaged & documented by carrier. Ineligible for warranty claims unless reports of defects are submitted within 14 days of delivery, cosmetic damage isn't covered."}</PDPAlertBar></div></DesktopOnly>}</div> : <div />;
    $[42] = isBrowser;
    $[43] = isOutOfStock;
    $[44] = loading;
    $[45] = mode;
    $[46] = showClearanceAlert;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== buildYourOwnDetails || $[49] !== isModularBundleProduct || $[50] !== mode) {
    t20 = mode === "pdp" && isModularBundleProduct && buildYourOwnDetails?.name ? <PDPAvailableInSizesListItem dimensions={buildYourOwnDetails.dimensions || ""} loading={false} id="byo" image="" isActive={false} name={`Build your own ${buildYourOwnDetails.name}`} byoCollectionName={buildYourOwnDetails.name} price="" urlKey={buildYourOwnDetails.urlKey} isBYO={true} /> : <div />;
    $[48] = buildYourOwnDetails;
    $[49] = isModularBundleProduct;
    $[50] = mode;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== isFlashSale || $[53] !== isMobileOrTablet || $[54] !== showClearanceMobileNotification) {
    t21 = !isFlashSale && isMobileOrTablet && showClearanceMobileNotification && <PDPNotification subheading={"This final sale product is eligible for cancellation within 24 hours\n            of order placement. Ineligible for returns except for items arriving\n            damaged & documented by carrier. Ineligible for warranty claims unless\n            reports of defects are submitted within 14 days of delivery, cosmetic\n            damage isn't covered."} onClose={() => setShowClearanceMobileNotification(false)} showCloseButton={false} baseStyleExtension="mb-4" />;
    $[52] = isFlashSale;
    $[53] = isMobileOrTablet;
    $[54] = showClearanceMobileNotification;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== t17 || $[57] !== t18 || $[58] !== t19 || $[59] !== t20 || $[60] !== t21) {
    t22 = <div className={t17} ref={addToBagSectionRef} data-xc="PDPAddToBagSectionUI">{t18}{t19}{t20}{t21}</div>;
    $[56] = t17;
    $[57] = t18;
    $[58] = t19;
    $[59] = t20;
    $[60] = t21;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  const t23 = !showStickyButtons;
  let t24;
  if ($[62] !== showStickyButtons || $[63] !== t23) {
    t24 = classNames("bg-white left-0 right-0 bottom-0 p-4 fixed z-20 lg:hidden", {
      "opacity-0 hidden": t23,
      "opacity-100 block": showStickyButtons
    });
    $[62] = showStickyButtons;
    $[63] = t23;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  const t25 = allowUserToCustomize && !overrideCustomize;
  let t26;
  if ($[65] !== addToCartError || $[66] !== addingToCart || $[67] !== campaign || $[68] !== cartDisabled || $[69] !== loading || $[70] !== onClick || $[71] !== t25) {
    t26 = <PDPAddToBagButton addingToCart={addingToCart} addToCartError={addToCartError} campaign={campaign} cartDisabled={cartDisabled} loading={loading} isCustomizeButton={t25} isStickyButton={true} onClick={onClick} />;
    $[65] = addToCartError;
    $[66] = addingToCart;
    $[67] = campaign;
    $[68] = cartDisabled;
    $[69] = loading;
    $[70] = onClick;
    $[71] = t25;
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  let t27;
  if ($[73] !== t24 || $[74] !== t26) {
    t27 = <MobileAndTabletOnly><FixedWidthContainer className={t24}>{t26}</FixedWidthContainer></MobileAndTabletOnly>;
    $[73] = t24;
    $[74] = t26;
    $[75] = t27;
  } else {
    t27 = $[75];
  }
  let t28;
  if ($[76] !== t22 || $[77] !== t27) {
    t28 = <>{t22}{t27}</>;
    $[76] = t22;
    $[77] = t27;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  return t28;
};
PDPAddToBagSectionUI.propTypes = {
  addingToCart: PropTypes.bool,
  addToCartError: PropTypes.string,
  allowUserToCustomize: PropTypes.bool,
  buildYourOwnDetails: PropTypes.shape({
    dimensions: PropTypes.string,
    name: PropTypes.string,
    urlKey: PropTypes.string
  }),
  cartDisabled: PropTypes.bool,
  showClearanceAlert: PropTypes.bool,
  isDiscontinued: PropTypes.bool,
  isModularBundleProduct: PropTypes.bool,
  isOutOfStock: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['quickview', 'pdp']),
  onAddToCart: PropTypes.func,
  stickyDesktopButtonOnly: PropTypes.bool,
  campaign: PropTypes.string,
  selectedMaterial: PropTypes.shape({
    exclude_from_sale: PropTypes.bool,
    additionalCost: PropTypes.number,
    description: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string,
    materialId: PropTypes.number,
    origAddlCost: PropTypes.number,
    upholsteryOptionId: PropTypes.number,
    value: PropTypes.string,
    sku: PropTypes.string
  })
};
export default PDPAddToBagSectionUI;